/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Pathfinder API
 * API for all Pathfinder applications.
 * OpenAPI spec version: 1.0.0
 */
import type {
  Journal,
  JournalListParams,
  JournalRequest,
  PaginatedJournalList
} from '../types';

import { apiV2 } from '../../mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  /**
 * Get a list of journals for the authenticated user's organization. Filter by user_id or checkin_id.
 * @summary List Journal Entries
 */
export const journalList = (
    params?: JournalListParams,
 options?: SecondParameter<typeof apiV2<PaginatedJournalList>>,) => {
      return apiV2<PaginatedJournalList>(
      {url: `/journal/`, method: 'GET',
        params
    },
      options);
    }
  /**
 * Create a new journal entry for the authenticated user.
 * @summary Create Journal Entry
 */
export const journalCreate = (
    journalRequest: JournalRequest,
 options?: SecondParameter<typeof apiV2<Journal>>,) => {
      return apiV2<Journal>(
      {url: `/journal/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: journalRequest
    },
      options);
    }
  /**
 * Retrieve a specific journal entry by its ID.
 * @summary Retrieve Journal Entry
 */
export const journalRetrieve = (
    id: string,
 options?: SecondParameter<typeof apiV2<Journal>>,) => {
      return apiV2<Journal>(
      {url: `/journal/${id}/`, method: 'GET'
    },
      options);
    }
  export type JournalListResult = NonNullable<Awaited<ReturnType<typeof journalList>>>
export type JournalCreateResult = NonNullable<Awaited<ReturnType<typeof journalCreate>>>
export type JournalRetrieveResult = NonNullable<Awaited<ReturnType<typeof journalRetrieve>>>
